// extracted by mini-css-extract-plugin
module.exports = {"heart":"Heart_heart__bML9a","lottie":"Heart_lottie__1U-od"};